// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import usersCheckIcon from "@/assets/icons/users-check.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type UsersCheckIconProps = Omit<IconProps, "name">;

export function UsersCheckIcon(props: UsersCheckIconProps): React.ReactNode {
  return <Icon name={usersCheckIcon} {...props} />;
}
